import React from "react";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import CustomDialog from "../shared/CustomDialog";
import CloseIcon from "../img/svg/close_blue_new_design.svg";

const AlmostFinishDialog = ({ open, onClose }) => {
  const { t } = useTranslation();

  return (
    <CustomDialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <Box>
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "3px",
            textAlign: "center",
          }}
          id="customized-dialog-title"
        >
          <img src={CloseIcon} alt="close" onClick={onClose} />
          <Typography
            className="open-sans-hebrew"
            gutterBottom
            sx={{
              fontSize: "24px",
              m: 0,
              color: "var(--darkblue)",
              textAlign: "center",
              fontWeight: 700,
              fontFamily: `var(--font-family) !important`,
            }}
          >
            {t("ALMOST_FINISH")}
          </Typography>
        </DialogTitle>
      </Box>

      <DialogContent>
        <Typography>
          <p className="almost-finish-dialog-text">{t("ALMOST_FINISH_TEXT")}</p>
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 0, m: 0 }}>
        <Button
          onClick={onClose}
          variant="contained"
          className="almost-finish-dialog-btn"
          sx={{ py: "16px", whiteSpace: "nowrap" }}
        >
          {t("PHONE_VALIDATION.CONTINUE")}
        </Button>
      </DialogActions>
    </CustomDialog>
  );
};

export default AlmostFinishDialog;
